import { Routes, Route } from "react-router";
import { DesignLabRoute } from "./DesignLabRoute";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/design-lab/:uuid?" Component={DesignLabRoute}></Route>
    </Routes>
  );
}
